import React from 'react';
import { Sparkles, ArrowUp } from 'lucide-react';

const AnimatedArrow = ({ x, y, width, height, color = 'hsl(var(--green-bright))' }) => {
    // Arrow dimensions
    const arrowSize = 32;

    // Calculate position: Center horizontally on the highlight, point down to the top of the highlight
    // or point left/right depending on space? Let's default to pointing AT the element from the left or top.
    // Standard "Look here" arrow usually points at the target.

    // Let's make it float to the left of the text and point right, or float above and point down.
    // Floating above is safer for long text.

    // Place the callout BELOW the target and point UP to it.
    // This works better for captions near the bottom of the page.
    const style = {
        position: 'absolute',
        left: x + (width / 2),
        top: y + height,
        transform: 'translate(-50%, 0)',
        pointerEvents: 'none',
        zIndex: 9999,
        filter: 'drop-shadow(0 8px 18px rgba(0,0,0,0.55))',
    };

    return (
        <div style={style} className="flex flex-col items-center animate-bounce z-[9999]">
            <ArrowUp
                className="w-10 h-10 text-[hsl(var(--green-bright))] drop-shadow-[0_6px_12px_rgba(0,0,0,0.65)] mb-1"
                strokeWidth={4}
            />
            <div className="bg-[hsl(var(--green-bright))] text-white px-3 py-1.5 rounded-full text-sm font-bold shadow-2xl whitespace-nowrap flex items-center gap-2 border-2 border-white">
                <Sparkles className="w-4 h-4 text-yellow-300 fill-current" />
                <span>Figure Here!</span>
            </div>
        </div>
    );
};

export default AnimatedArrow;
